import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { WorkStationInactivityModal } from './components/WorkStationInactivityModal';
import { useWorkStationInactivityModal } from './hooks/useWorkStationInactivityModal';

const WorkStationInactivityController = ({ lastActivityDate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { registerActivity, expireSession } = useWorkStationInactivityModal({
    lastActivityDate,
    handleInactivity: () => setIsModalOpen(true),
  })

  const handleLogOut = () => {
    setIsModalOpen(false);
    expireSession();
  };

  const handleContinue = () => {
    setIsModalOpen(false);
    registerActivity();
  };

  return (
    <WorkStationInactivityModal
      show={isModalOpen}
      onLogOut={handleLogOut}
      onContinue={handleContinue}
    />
  );
};

WorkStationInactivityController.propTypes = {
  lastActivityDate: PropTypes.instanceOf(Date).isRequired,
};

export { WorkStationInactivityController };
